import MCardList from './index.vue';

MCardList.install = app => {
  app.component(MCardList.name, MCardList);
};

export default MCardList;
